import {
  FleetWarehouseContactFormValues,
  FleetWarehouseDetailFormValues,
  FleetWarehouseEditFormValues,
  FleetWarehouseSearchFormValues,
  WarehouseWorkingDay,
} from "./types";

/*-------------------------------------------------------------------------------------------
  RADNO VRIJEME
---------------------------------------------------------------------------------------------*/

export const WAREHOUSE_WEEK_DAYS = [
  { day: 1, label: "Ponedjeljak", short: "Pon" },
  { day: 2, label: "Utorak", short: "Uto" },
  { day: 3, label: "Srijeda", short: "Sri" },
  { day: 4, label: "Četvrtak", short: "Čet" },
  { day: 5, label: "Petak", short: "Pet" },
  { day: 6, label: "Subota", short: "Sub" },
  { day: 7, label: "Nedjelja", short: "Ned" },
];

export const WAREHOUSE_DEFAULT_OPEN_FROM = "08:00";
export const WAREHOUSE_DEFAULT_OPEN_TO = "16:00";

/** Novo skladište: radnim danima 8 do 16, vikendom zatvoreno. */
export const initialWarehouseWorkingHours: WarehouseWorkingDay[] = WAREHOUSE_WEEK_DAYS.map(({ day }) => ({
  day,
  isOpen: day <= 5,
  from: WAREHOUSE_DEFAULT_OPEN_FROM,
  to: WAREHOUSE_DEFAULT_OPEN_TO,
}));

/*-------------------------------------------------------------------------------------------
  FLEET WAREHOUSE EDIT
---------------------------------------------------------------------------------------------*/

export const initialFleetWarehouseEditForm: FleetWarehouseEditFormValues = {
  name: null,
  image: null,
  description: null,
  workingHours: initialWarehouseWorkingHours,
  addressCity: "",
  addressCountry: "",
  addressLine1: "",
  addressLine2: "",
  addressPostalCode: "",
  addressState: "",
  addressLatitude: null,
  addressLongitude: null,
  contacts: [],
};

export const initialFleetWarehouseContactForm: FleetWarehouseContactFormValues =
  {
    contactId: null,
  };

/*-------------------------------------------------------------------------------------------
  FLEET WAREHOUSE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialFleetWarehouseSearchForm: FleetWarehouseSearchFormValues = {
  search: "",
  address: "",
  contactId: null,
};

/*-------------------------------------------------------------------------------------------
    FLEET WAREHOUSE DETAILS
---------------------------------------------------------------------------------------------*/

export const initialFleetWarehouseDetailForm: FleetWarehouseDetailFormValues = {
  id: null,
  name: null,
  description: null,
  workingHours: [],
  addressCity: "",
  addressCountry: "",
  addressLine1: "",
  addressLine2: "",
  addressPostalCode: "",
  addressState: "",
  addressLatitude: null,
  addressLongitude: null,
  contacts: [],
};
